/**
 * Paper ↔ night.
 *
 * Lives on its own because two different chromes need it: the sidebar head on a
 * desktop, and the top bar on a phone where the sidebar has become a drawer and
 * taken its own head with it.
 */

import { Moon, Sun } from "lucide-react";
import { useTheme } from "../theme.tsx";
import { IconAction } from "./IconAction.tsx";

export function ThemeToggle({ className }: { readonly className?: string }) {
  const { mode, toggle } = useTheme();

  return (
    <IconAction
      label={mode === "paper" ? "Switch to night" : "Switch to paper"}
      onClick={toggle}
      {...(className !== undefined ? { className } : {})}
    >
      {mode === "paper" ? <Moon /> : <Sun />}
    </IconAction>
  );
}
